import { buildApiUrl, Type, sendGetRequest } from '@/api/api';
import { assertSchemaAndCoerce } from '@/shared/utils/schemas/assertions'
import { z } from 'zod'

export async function fetchTariffYears(ids: number[]) {
  const query = ids.map(id => `tariffIds=${id}`).join('&');
  const url = buildApiUrl(Type.TariffManagement, `tariffs/years?${query}`)
  const { data } = await sendGetRequest(url)
  return assertSchemaAndCoerce(data, z.array(z.number()))
}
